import type { FileInput } from 'gql/graphql';

import { useEffect, useState } from 'react';

const read = (file: File, onRead: (fileInput: FileInput) => void) => {
    const reader = new FileReader();

    reader.addEventListener('load', () => onRead({ dataUrl: reader.result as string, name: file.name }), false);

    reader.readAsDataURL(file);
};

const readFilesAsBase64 = (files: File[], onSuccess: (result: FileInput[]) => void) => {
    let processed: FileInput[] = [];

    const onRead = (fileInput: FileInput) => {
        processed = [...processed, fileInput];

        if (processed.length === files.length) {
            onSuccess(processed);
        }
    };

    if (files.length) {
        for (let i = 0; i <= files.length; i++) {
            if (files[i]) {
                read(files[i], onRead);
            }
        }
    }
};

export const useReadFilesAsBase64 = (files?: File[]): FileInput[] | undefined => {
    const [result, setResult] = useState<undefined | FileInput[]>();

    useEffect(() => {
        if (files?.length) {
            readFilesAsBase64(files, setResult);
        } else {
            setResult(undefined);
        }
    }, [files]);

    return result;
};
